import React from 'react';
const IconMiscStepsAlt = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 5H12V7H21V5Z" fill="#2D2E2E"/>
<path d="M17 11H8V13H17V11Z" fill="#2D2E2E"/>
<path d="M12 17H3V19H12V17Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscStepsAlt;